export default __webpack_public_path__ + "static/media/alert.9235730b.svg";